/* Routing */
import { Link } from "react-router-dom";
/* Resources */
import { CSVLink} from "react-csv";
/* Helpers */
import { toggleDetailsView } from "../../helper/toggleMenuView";
import useData from "../../hooks/useData";
import {useEffect, useRef, useState} from "react";
import {getActivityList} from "../../api/admin/activityReq";
import useAuth from "../../hooks/useAuth";

export default function SearchBox({ className, location, headers, filename, setFilterParams }) {

    const { auth } = useAuth();
    const token = auth.token;
    const [ filter, setFilter ] = useState({});
    const [ dataFilteredList, setDataFilteredList ] = useState();
    const searchDivRef = useRef();
    const [isInitialized, setIsInitialized] = useState(false);

    const {
        dataList,
        activityList, setActivityList
    } = useData();

    const storageKey = `searchFilters_${location}`;

    const agencyFilters = [
        {"name" : "Nom"},
        {"siret" : "Siret"},
        {"zipcode" : "Code postal"},
        {"city" : "Ville"},
        {"activity" : "Activités"}
    ];

    const networkFilters = [
        {"name" : "Nom"},
        {"siret" : "Siret"},
    ];

    const userFilters = [
        {"agencyName" : "Agence"},
        {"roles" : "Rôle"},
        {"firstName" : "Prénom"},
        {"lastName" : "Nom"},
        {"email" : "Email"},
        {"active" : "Utilisateur actif ?"}
    ];

    const documentsFilters = [
        {"name" : "Nom du document"},
    ];

    /*const citiesFilters = [
        {"name" : "Nom"},
        {"zipcode" : "Code postal"},
    ];*/

    const billingFilters = [
        {"agency" : "Agence de facturation"},
        {"from" : "Du :"},
        {"to" : "Au :"},
    ];

    const deceasedFilters = [
        {"agency" : "Agence"},
        {"lastName" : "Nom"},
        {"firstName" : "Prénom"},
        {"deathDate" : "Décès le"}
    ];

    let filters;

    switch (location) {
        case "Agences":
            filters = agencyFilters
            break;
        case "Réseaux":
            filters = networkFilters
            break;
        case "Utilisateurs":
            filters = userFilters
            break;
        case "Documents":
            filters = documentsFilters
            break;
        /*case "Villes":
            filters = citiesFilters
            break;*/
        case "Facturation":
            filters = billingFilters
            break;
        case "Défunts":
            filters = deceasedFilters
        break;
            default:
            filters = []
    }

    const handleFilter = (e) => {
        const newFilter = { ...filter, [e.target.name] : e.target.value };

        setFilter(newFilter);

        if (e.target.name === "activity") {
            setDataFilteredList(dataList?.filter(data => data['activity'].find(activity => activity?.activityId == e.target.value)));
        } else if (e.target.name === "roles") {
            setDataFilteredList(dataList?.filter(data => data['roles'].find(role => role === e.target.value)));
        } else if (e.target.name === "active") {
            if (e.target.value === "" || e.target.value === "indifferent") {
                setDataFilteredList(dataList)
            } else {
                setDataFilteredList(dataList?.filter(data => data['enabled'] == e.target.value))
            }
        } else {
            setDataFilteredList(dataList?.filter(
                data => {
                    const dataValue = (data[e.target.name] || '').toString().replace(/\s+/g, '').toLowerCase();
                    const searchValue = (e.target.value || '').toString().replace(/\s+/g, '').toLowerCase();
                    return dataValue.includes(searchValue);
                }
            ))
        }

        // Sauvegarder dans localStorage
        if (location === "Utilisateurs" || location === "Agences" || location === "Documents" || location === "Réseaux" || location === "Défunts") {
            localStorage.setItem(storageKey, JSON.stringify(newFilter));
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            setFilterParams(filter);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault()
        setFilterParams(filter);
    }

    const handleReset = (e) => {
        e.preventDefault();
        setFilter({});
        setFilterParams({});
        setDataFilteredList(dataList);

        // Supprimer du localStorage
        localStorage.removeItem(storageKey);

        // Réinitialiser tous les champs du formulaire
        const form = searchDivRef.current?.querySelector('form');
        if (form) {
            form.reset();
        }
    }

    const apiActivityList = async () => {
        const response = await getActivityList(token);
        setActivityList(response);
    }

    const csvReport = {
        // react-csv plante dès le rendu si data n'est pas un tableau (ex: undefined pendant un
        // rechargement de la liste, comme lors d'un changement du nombre d'éléments par page).
        data : dataList || [],
        headers : headers,
        filename : filename,
    };

    const roleList = [
        { key: "ROLE_PF", name: "PF" },
        { key: "ROLE_UPF", name: "UPF" },
        { key: "ROLE_BACKEBD", name: "Super administrateur" },
        { key: "ROLE_GROUPEMENT", name: "Ensemble" }
    ];

    useEffect(() => {
        apiActivityList()
    },[])

    // Restaurer les filtres depuis localStorage au montage
    useEffect(() => {
        const savedFilters = localStorage.getItem(storageKey);
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilter(parsedFilters);
                setFilterParams(parsedFilters);
                setIsInitialized(true);
            } catch (error) {
                console.error('Erreur lors du parsing des filtres:', error);
                localStorage.removeItem(storageKey);
            }
        } else {
            setIsInitialized(true);
        }
    }, [location]);

    // Restaurer les valeurs dans les champs du formulaire après le chargement
    useEffect(() => {
        if (isInitialized && filter && Object.keys(filter).length > 0) {
            const form = searchDivRef.current?.querySelector('form');
            if (form) {
                Object.entries(filter).forEach(([key, value]) => {
                    const input = form.querySelector(`[name="${key}"]`);
                    if (input) {
                        input.value = value;
                    }
                });
            }
        }
    }, [isInitialized, filter]);

    return (
        <div ref={searchDivRef} className={`details search ${ (className !== undefined) && className }`}>
            <div className="arrow" onClick={toggleDetailsView}>
                <span><i className="fa fa-chevron-left"></i></span>
            </div>

            <div className="double-legend">
                { (location !== "Utilisateurs" && location !== "Défunts") &&
                    <legend>
                        <button>
                            <Link to="0/voir">
                                <i className="fa fa-plus"></i>
                                <span>Ajouter</span>
                            </Link>
                        </button>
                    </legend>
                }
                <legend>
                    <button type="button" onClick={toggleDetailsView}>
                        <i className="fa fa-search"></i>
                        <span>Rechercher</span>
                    </button>
                </legend>
            </div>

            <form onSubmit={handleSubmit} className="details-content">
                { filters?.map((filterItem, index) => (
                    <div key={index}>
                        <label htmlFor={Object.keys(filterItem)[0]}>{Object.values(filterItem)[0]}</label>
                        {
                            (Object.keys(filterItem)[0] === "activity")
                                ? <div className="form-input">
                                    <select name="activity" onChange={handleFilter} value={filter.activity || ""}>
                                        <option name="activity" value="">Toutes activités</option>
                                        { activityList?.filter(activity => activity?.activityEnabled)?.map(activity => (
                                            <option key={activity.id} name="activity" value={activity.id}>{activity.name}</option>
                                        ))}
                                    </select>
                                </div>
                                : (location === "Utilisateurs" && Object.keys(filterItem)[0] === "active")
                                ? <div className="form-input">
                                    <select name="active" onChange={handleFilter} value={filter.active || ""}>
                                        <option name="active" value="">Indifférent</option>
                                        <option name="active" value="true">Oui</option>
                                        <option name="active" value="false">Non</option>
                                    </select>
                                </div>
                                : (location === "Utilisateurs" && Object.keys(filterItem)[0] === "roles") ?
                                    <div key={index} className="form-input">
                                        <select name="roles" onChange={handleFilter} value={filter.roles || ""}>
                                            <option name="roles" value="">Tous les rôles</option>
                                            { roleList?.map(role => (
                                                <option key={role?.key} name="roles" value={role?.key}>{role?.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                : <div className="form-input">
                                    <input name={Object.keys(filterItem)[0]} type="search" onKeyUp={handleFilter} onKeyDown={handleKeyDown}/>
                                </div>
                        }
                    </div>
                ))}

                <div className="search-buttons">
                    <button onClick={handleReset} className="search-button"><i className="fa fa-close"/><span>Effacer</span></button>
                    <button type="submit" className="green-button"><i className="fa fa-search"/><span>Rechercher</span></button>
                </div>
                <button className="export"><CSVLink {...csvReport}><i className="fa fa-upload"/><span>Exporter la liste filtrée</span></CSVLink></button>
            </form>
        </div>
    )
}